import i18n from '@/js/vue-i18n';
import offerMechanicTemplates from '@enums/offer-mechanic-templates';

const TEMPLATES_I18N_BASE = 'planning.promotionsMaintenance.offer.offerMechanic.templates';

/**
 * Label for a preset or price tag. System entries are stored with name === key, so they use
 * the translated template name; vue-i18n returns the key itself when no translation exists.
 */
export const getOfferTemplateLabel = ({ key, name, currencySymbol = '' }) => {
    if (name && name !== key) return name;
    const translationKey = `${TEMPLATES_I18N_BASE}.${key}`;
    const translation = i18n.global.t(translationKey, { currencySymbol });
    return translation !== translationKey ? translation : name || key;
};

export const DEFAULT_PRICE_TAG_ID = offerMechanicTemplates.newPricePerItem;

export const getPriceTagLabel = ({ id, name, currencySymbol = '' }) => {
    if (!id) return '';
    const label = getOfferTemplateLabel({ key: id, name, currencySymbol });
    return id === DEFAULT_PRICE_TAG_ID
        ? `${label} (${i18n.global.t('admin.offerPresets.defaultSuffix')})`
        : label;
};

export default { getOfferTemplateLabel, getPriceTagLabel };
